import { render, staticRenderFns } from "./GPTVoice.vue?vue&type=template&id=52a43da5&scoped=true&"
import script from "./GPTVoice.vue?vue&type=script&lang=js&"
export * from "./GPTVoice.vue?vue&type=script&lang=js&"
import style0 from "./GPTVoice.vue?vue&type=style&index=0&id=52a43da5&prod&scoped=true&lang=css&"
import style1 from "./GPTVoice.vue?vue&type=style&index=1&id=52a43da5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a43da5",
  null
  
)

export default component.exports